import { Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { MdDialog, MdSelectChange } from '@angular/material';
import { SendMessageComponent } from '../send-message/send-message.component';
import { UserProfile, Status } from '../../models/user-profile';
import { Annotation } from '../../models/annotation';
import { FullProfileService } from '../../services/full-profile.service';
import { ApplicantService } from '../../services/applicant.service';
import { AnnotationService } from '../../services/annotation.service';
import { Profile } from '../../models/profile';
import { MessagingService } from '../../services/messaging.service';
import { ApplyStatusService } from '../../services/apply-status.service';
import { SentMessageDialogComponent } from '../sent-message-dialog/sent-message-dialog.component';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Message } from '../../models/message';
import { HighlightPipe } from '../pipes/highlight.pipe';
import {Observable} from "rxjs";
import { JobSelectorDialogComponent } from '../job-selector-dialog/job-selector-dialog.component';
import { AnnotationDialogComponent } from '../annotation-dialog/annotation-dialog.component';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { Constants } from '../constants';

@Component({
  selector: 'app-cv-map',
  templateUrl: './cv-map.component.html',
  styleUrls: ['./cv-map.component.css']
})

export class CvMapComponent implements OnChanges, OnInit{
  @Input() userId: string;
  viewAddNotes: boolean = false;
  viewNotes: boolean = false;
  viewMessages: boolean = false;
  selectedOption: string;
  @Input() nameComponent;
  errorMessage: string;
  profileSubscription;
  currentProfile: UserProfile;
  newAnnotation: string;
  messages: Observable<Message[]>;
  msgLoading: boolean;
  msgMax: number = 3;
  msgPage: number = 1;
  msgTotal: number = 0;
  num: number = 0;
  applyStatusList: any;
  filters: any;
  query_desc_edu: string ="";
  reco:any;

  annotations: Observable<Annotation[]>;
  noteLoading: boolean;
  noteMax: number = 1;
  notePage: number = 1;
  noteTotal: number = 0;

  loading: boolean = false;
  bool: boolean = this.data.reco;
  long:number = 0;
  cvError: boolean = false;
  premium: string;
  filter: string;
  fil: string;
  fil2: string;

  @Output() favoriteChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() statusChanged: EventEmitter<Status> = new EventEmitter<Status>();

  public STATUS = Constants;

  constructor(public dialog: MdDialog,
              public profile: FullProfileService,
              public annotation: AnnotationService,
              public applicant: ApplicantService,
              @Inject(MD_DIALOG_DATA) public data: any,
              public message: MessagingService,

              ) {
                if (data) {
                  this.userId = data.userId;
                }
  }

  ngOnInit () {

    if (this.data.reco){
       this.filters = this.data.filters;
       this.filter=" ";

       let toArray = this.filters.title.split(" ");  
                    
       for (let i = 0; i < toArray.length; i++) {
         this.long = toArray[i].length

         if(this.long>3 ){
              this.filter=this.filter +" "+ toArray[i].replace('.'," ");
        }       
       }
        this.filters.query_exp=this.filter;
        this.filters.query_edu=this.filter;       

    }else{
      this.filters = this.data.filters;
      if(this.filters.query_description != ""){
        if(this.filters.query_edu != ""){
          this.query_desc_edu = this.filters.query_edu + " " + this.filters.query_description;
        }else{
          this.query_desc_edu = this.filters.query_description;
        }
      }else{
        if(this.filters.query_edu != ""){
          this.query_desc_edu = this.filters.query_edu;
        }
      }
    }
    
    


    if (localStorage.getItem('premium')){
      this.premium = localStorage.getItem('premium');
    } else {
      this.premium = '0';
    }

    if (this.userId != undefined) {
      this.fetchProfile(this.userId);
      this.fetchAnnotations(1);
      this.fetchMessages(1);
    } 

  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['userId'] && (changes['userId'].previousValue !== changes['userId'].currentValue)) {
      this.fetchProfile(this.userId);
      this.fetchAnnotations(1);
      this.fetchMessages(1);
    }
  }



  fetchProfile(userId) {
    this.loading = true;
    this.profileSubscription = this.profile.getProfile(userId)
      .subscribe(
        profile => this.processProfile(profile),
        error => {
          this.errorMessage = <any>error;
          this.cvError = true;
          this.loading = false;
          this.currentProfile = null;
        }
      );
  }

  downloadPDF(){
    this.applicant.getApplicantResume(this.userId).subscribe(
      data => {
        const fileURL = URL.createObjectURL(data);
        const link = document.createElement('a');
        link.download = this.currentProfile.firstname + this.currentProfile.lastname + '.pdf';
        link.target = '_blank';
        link.href = fileURL;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
  }

  asCurrentDate(strdate): string {
    return (strdate === null || strdate === '0000-00-00') ? 'Actualmente' : strdate;
  }

  fetchAnnotations(page) {
    this.noteTotal = 0;
    this.noteLoading = true;
    this.annotations = this.annotation.getAnnotation(this.userId, undefined, page, this.noteMax)
      .do(res => {
        this.noteTotal = res.pagination.total;
        this.notePage = page;
        this.noteLoading = false;
      })
      .map(res => res.annotations);
  }

  fetchMessages(page) {
    this.msgTotal = 0;
    this.msgLoading = true;
    this.messages = this.message.getMessage(this.userId, undefined, page, this.msgMax)
      .do(res => {
        this.msgTotal = res.pagination.total;
        this.msgPage = page;
        this.msgLoading = false;
      })
      .map(res => res.messages);
  }

    profileCompletionRequest() {
      this.message.sendprofileCompletionRequest(this.userId)
      .subscribe(
        data =>this.dialog.open(MessageBoxDialog, {data: {message: "Solicitud Enviada", success:true, showIcon:true}}),
        error => {this.dialog.open(MessageBoxDialog, {data: {message: "Solicitud No Enviada: "+error, alert:true, showIcon:true}})}
      );
    }

  processProfile(profile) {
    this.currentProfile = profile;
    this.loading = false;
    this.cvError = false;
  }

  changeView(view) {
    if (view == 'viewAddNotes') {
        this.viewAddNotes = !this.viewAddNotes;
      this.viewNotes = false;
      this.viewMessages = false;
    } else if (view == 'viewMessages') {
      if(this.msgTotal > 0)
        this.viewMessages = !this.viewMessages;
      this.viewNotes = false;
      this.viewAddNotes = false;
    } else {
      if(this.noteTotal > 0)
        this.viewNotes = !this.viewNotes;
      this.viewAddNotes = false;
      this.viewMessages = false;
    }
  }



  goToMap () {
    let lato = this.currentProfile.location.lat;
    let lngo = this.currentProfile.location.lng;
    let urlMap = 'https://maps.google.com?q='+lato+','+lngo;
    window.open(urlMap, '_blank');
  }

  onInvite() {
    this.openDialogJobSelectorDialog();
  }

  openDialogJobSelectorDialog() {
    let dialogRef = this.dialog.open(JobSelectorDialogComponent);
    dialogRef.componentInstance.createInvite=true;
    dialogRef.componentInstance.UserID=this.userId;
    dialogRef.componentInstance.nameComponent='Invitación';
    dialogRef.componentInstance.hv='0';

    dialogRef.afterClosed().subscribe(result => {
      if (result != "YES") {
        // this.dialog.open(MessageBoxDialog, {data: {message: 'Invitación Enviada', success: true, showIcon:true}});
      }
    });
  }

  openNotes() {
    let dialogRef = this.dialog.open(AnnotationDialogComponent, {data: {
      userId: this.userId,
      page: 1,
      noteMax: this.noteMax,
      noteTotal: this.noteTotal
    }});
    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
      this.fetchAnnotations(1);
    });
  }

  openMessages() {
    if (this.msgTotal !== 0) {
      let dialogRef = this.dialog.open(MessageDialogComponent, {data: {
        userId: this.userId,
        page: 1,
        msgMax: this.msgMax,
        msgTotal: this.msgTotal
      }});
    }
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/cv-map/cv-map.component.ts